import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CookieBanner"] */ "/vercel/path0/components/consent/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/context/DesignerContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DeepLinkListener"] */ "/vercel/path0/components/DeepLinkListener.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleTags"] */ "/vercel/path0/components/GoogleTags.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OfflineAutoSwitch"] */ "/vercel/path0/components/OfflineAutoSwitch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OfflineSyncProvider"] */ "/vercel/path0/components/providers/OfflineSyncProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/components/providers/ThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PullToRefresh"] */ "/vercel/path0/components/PullToRefresh.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReducedMotionProvider"] */ "/vercel/path0/components/ReducedMotionProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegister"] */ "/vercel/path0/components/ServiceWorkerRegister.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-big-calendar/lib/css/react-big-calendar.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
